var Profile = function() {
    var changePwd = function() {
        UserDataValidation.hidePasswordPrompts();
        var pwd = $('#password').val();

        if (UserDataValidation.checkPwd(pwd, true)) {
            Ajax.changePwd(pwd, function(res) {
                if (!res || !res.success || res.success != 'ok') {
                    UserDataValidation.showPasswordErrorPrompt('server');
                } else {
                    UserDataValidation.showPasswordSuccess();
                }
            });
        }
    };

    return {
        init: function() {
            $('#change_pass_btn').click(function() {
                changePwd();
            });
            $('.ii__pwd_container input').keyup(function(ev) {
                if (ev.which == 13) {
                    changePwd();
                }
            });
        }
    };
}();
